import _defineProperty from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { unit } from '@ant-design/cssinjs'; // =====================================================
// ==                  Outlined                       ==
// =====================================================

var genBaseOutlinedStyle = function genBaseOutlinedStyle(token, options) {
  var _not$concat$concat, _ref;

  var componentCls = token.componentCls,
      antCls = token.antCls,
      controlOutlineWidth = token.controlOutlineWidth;
  return _ref = {}, _defineProperty(_ref, "&:not(".concat(componentCls, "-customize-input) ").concat(componentCls, "-selector"), {
    border: "".concat(unit(token.lineWidth), " ").concat(token.lineType, " ").concat(options.borderColor),
    background: token.selectorBg
  }), _defineProperty(_ref, "&:not(".concat(componentCls, "-disabled):not(").concat(componentCls, "-customize-input):not(").concat(antCls, "-pagination-size-changer)"), (_not$concat$concat = {}, _defineProperty(_not$concat$concat, "&:hover ".concat(componentCls, "-selector"), {
    borderColor: options.hoverBorderHover
  }), _defineProperty(_not$concat$concat, "".concat(componentCls, "-focused& ").concat(componentCls, "-selector"), {
    borderColor: options.activeBorderColor,
    boxShadow: "0 0 0 ".concat(unit(controlOutlineWidth), " ").concat(options.activeShadowColor),
    outline: 0
  }), _not$concat$concat)), _ref;
};

var genOutlinedStatusStyle = function genOutlinedStatusStyle(token, options) {
  return _defineProperty({}, "&".concat(token.componentCls, "-status-").concat(options.status), Object.assign({}, genBaseOutlinedStyle(token, options)));
};

var genOutlinedStyle = function genOutlinedStyle(token) {
  var _Object$assign;

  return {
    '&-outlined': Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseOutlinedStyle(token, {
      borderColor: token.colorBorder,
      hoverBorderHover: token.colorPrimaryHover,
      activeBorderColor: token.colorPrimary,
      activeShadowColor: token.controlOutline
    })), genOutlinedStatusStyle(token, {
      status: 'error',
      borderColor: token.colorError,
      hoverBorderHover: token.colorErrorHover,
      activeBorderColor: token.colorError,
      activeShadowColor: token.colorErrorOutline
    })), genOutlinedStatusStyle(token, {
      status: 'warning',
      borderColor: token.colorWarning,
      hoverBorderHover: token.colorWarningHover,
      activeBorderColor: token.colorWarning,
      activeShadowColor: token.colorWarningOutline
    })), (_Object$assign = {}, _defineProperty(_Object$assign, "&".concat(token.componentCls, "-disabled"), _defineProperty({}, "&:not(".concat(token.componentCls, "-customize-input) ").concat(token.componentCls, "-selector"), {
      background: token.colorBgContainerDisabled,
      color: token.colorTextDisabled
    })), _defineProperty(_Object$assign, "&".concat(token.componentCls, "-multiple ").concat(token.componentCls, "-selection-item"), {
      background: token.multipleItemBg,
      border: "".concat(unit(token.lineWidth), " ").concat(token.lineType, " ").concat(token.multipleItemBorderColor)
    }), _Object$assign))
  };
}; // =====================================================
// ==                   Filled                        ==
// =====================================================


var genBaseFilledStyle = function genBaseFilledStyle(token, options) {
  var _not$concat$concat2, _ref3;

  var componentCls = token.componentCls,
      antCls = token.antCls;
  return _ref3 = {}, _defineProperty(_ref3, "&:not(".concat(componentCls, "-customize-input) ").concat(componentCls, "-selector"), {
    background: options.bg,
    border: "".concat(unit(token.lineWidth), " ").concat(token.lineType, " transparent"),
    color: options.color
  }), _defineProperty(_ref3, "&:not(".concat(componentCls, "-disabled):not(").concat(componentCls, "-customize-input):not(").concat(antCls, "-pagination-size-changer)"), (_not$concat$concat2 = {}, _defineProperty(_not$concat$concat2, "&:hover ".concat(componentCls, "-selector"), {
    background: options.hoverBg
  }), _defineProperty(_not$concat$concat2, "".concat(componentCls, "-focused& ").concat(componentCls, "-selector"), {
    background: token.selectorBg,
    borderColor: options.activeBorderColor,
    outline: 0
  }), _not$concat$concat2)), _ref3;
};

var genFilledStatusStyle = function genFilledStatusStyle(token, options) {
  return _defineProperty({}, "&".concat(token.componentCls, "-status-").concat(options.status), Object.assign({}, genBaseFilledStyle(token, options)));
};

var genFilledStyle = function genFilledStyle(token) {
  var _Object$assign2;

  return {
    '&-filled': Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseFilledStyle(token, {
      bg: token.colorFillTertiary,
      hoverBg: token.colorFillSecondary,
      activeBorderColor: token.colorPrimary,
      color: token.colorText
    })), genFilledStatusStyle(token, {
      status: 'error',
      bg: token.colorErrorBg,
      hoverBg: token.colorErrorBgHover,
      activeBorderColor: token.colorError,
      color: token.colorError
    })), genFilledStatusStyle(token, {
      status: 'warning',
      bg: token.colorWarningBg,
      hoverBg: token.colorWarningBgHover,
      activeBorderColor: token.colorWarning,
      color: token.colorWarning
    })), (_Object$assign2 = {}, _defineProperty(_Object$assign2, "&".concat(token.componentCls, "-disabled"), _defineProperty({}, "&:not(".concat(token.componentCls, "-customize-input) ").concat(token.componentCls, "-selector"), {
      borderColor: token.colorBorder,
      background: token.colorBgContainerDisabled,
      color: token.colorTextDisabled
    })), _defineProperty(_Object$assign2, "&".concat(token.componentCls, "-multiple ").concat(token.componentCls, "-selection-item"), {
      background: token.colorBgContainer,
      border: "".concat(unit(token.lineWidth), " ").concat(token.lineType, " ").concat(token.colorSplit)
    }), _Object$assign2))
  };
}; // =====================================================
// ==                 Borderless                      ==
// =====================================================


var genBorderlessStyle = function genBorderlessStyle(token) {
  var _borderless;

  return {
    '&-borderless': (_borderless = {}, _defineProperty(_borderless, "".concat(token.componentCls, "-selector"), {
      background: 'transparent',
      borderColor: 'transparent'
    }), _defineProperty(_borderless, "&".concat(token.componentCls, "-disabled"), _defineProperty({}, "&:not(".concat(token.componentCls, "-customize-input) ").concat(token.componentCls, "-selector"), {
      color: token.colorTextDisabled
    })), _defineProperty(_borderless, "&".concat(token.componentCls, "-multiple ").concat(token.componentCls, "-selection-item"), {
      background: token.multipleItemBg,
      border: "".concat(unit(token.lineWidth), " ").concat(token.lineType, " ").concat(token.multipleItemBorderColor)
    }), _defineProperty(_borderless, "&".concat(token.componentCls, "-status-error"), _defineProperty({}, "".concat(token.componentCls, "-selection-item"), {
      color: token.colorError
    })), _defineProperty(_borderless, "&".concat(token.componentCls, "-status-warning"), _defineProperty({}, "".concat(token.componentCls, "-selection-item"), {
      color: token.colorWarning
    })), _borderless)
  };
};

var genVariantsStyle = function genVariantsStyle(token) {
  return _defineProperty({}, token.componentCls, Object.assign(Object.assign(Object.assign({}, genOutlinedStyle(token)), genFilledStyle(token)), genBorderlessStyle(token)));
};

export default genVariantsStyle;